var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.7 4.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uC790\uC0B0 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.3,4.9a2.5,2.5,0,0,1-1.8-.8,1.8,1.8,0,0,1-.5-.7,3,3,0,0,1-.2-1A2.8,2.8,0,0,1,16.5.7l.4-.3.4-.2.5-.2A2.6,2.6,0,0,1,20,.7a2.8,2.8,0,0,1,.7,1.7,3,3,0,0,1-.2,1,1.8,1.8,0,0,1-.5.7A2.5,2.5,0,0,1,18.3,4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.9,2.4A2.5,2.5,0,0,1,10.4,0h0a2.4,2.4,0,0,1,2.4,2.4h0a2.5,2.5,0,0,1-2.4,2.5h0A2.5,2.5,0,0,1,7.9,2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.4,4.9A2.5,2.5,0,0,1,.7,4.1,2.4,2.4,0,0,1,0,2.4V2l.2-.5c.1-.1.1-.3.2-.4L.7.7A2.5,2.5,0,0,1,4.1.7a.5.5,0,0,1,.3.4l.3.4c0,.2.1.3.1.5s.1.3.1.4a2.1,2.1,0,0,1-.8,1.7,2,2,0,0,1-.7.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.a1ae03c150c1ebccc0eb3e6a85f40d3a.svg";
export { ForwardRef as ReactComponent };